import React, { Component } from 'react'
import classnames from 'classnames'
import Label from './label'
import FieldError from './fielderror'
import Help from './help'
import SubHelp from './subhelp'

/* eslint-disable react/prop-types */

class RadioInput extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: this.props.value,
            showTooltip: false,
            tooltipPosition: null,
            focused: false,
            options: this.props.options || [],
            available_options: null,
        }
    }

    componentWillReceiveProps(nextProps) {
        let newState = {}

        if (nextProps.value !== this.state.value) {
            newState = {
                value: nextProps.value,
            }
        }

        if (this.props.options.length !== nextProps.options.length) {
            newState.options = nextProps.options
        }

        if (newState !== {}) {
            this.setState(newState)
        }
    }

    /*
     * Handle a radio value choice
     */
    _handleChange = (value) => {
        this.setState(
            { value },
            () => this.props.updateValue({ [this.props.name]: value })
        )
    }

    /*
     * Handle focus
     */
    _handleFocus = (e) => {
        this.props.handleFocus && this.props.handleFocus(e)
    }

    /*
     * Handle focus
     */
    _handleBlur = (e) => {
        this.props.handleBlur && this.props.handleBlur(e)
    }

    render() {
        const input_id = `id_${ this.props.name }`

        const groupClasses = classnames({
            'form__group': true,
            'form__group--error': this.props.error,
            'form__group--required': this.props.required,
        })

        const controlClasses = classnames({
            'form__control': true,
        })

        /*
         * Add a default option for no selection
         */
        let optionList = null

        if (this.state.options.length > 0) {
            optionList = this.state.options.map((item, index) => {
                const option_id = `${ input_id }-${ index }`

                return (
                    <li key={ item.value }>
                        <label htmlFor={ option_id }>
                            <input
                                checked={ item.value === this.state.value }
                                className="form__radio"
                                id={ option_id }
                                name={ this.props.name }
                                onBlur={ this._handleBlur }
                                onChange={ () => this._handleChange(item.value) }
                                onFocus={ this._handleFocus }
                                required={ this.props.required }
                                type="radio"
                                value={ item.value }
                            />
                            <span className="control-radio__label">{ item.label }</span>
                        </label>
                    </li>
                )
            })
        }

        return (
            <div className={ groupClasses }>
                <Label>{ this.props.label }</Label>
                <FieldError
                    error={ this.props.error }
                    on={ this.state.showTooltip }
                    position={ this.state.tooltipPosition }
                />
                <div className={ controlClasses } ref="form-control">
                    <ul className="control-radio__options" >{ optionList }</ul>
                    <Help
                        help={ this.props.help }
                        on={ this.state.showTooltip && ! this.props.error }
                        position={ this.state.tooltipPosition }
                    />
                    <SubHelp help={ this.props.subHelp }/>
                </div>
            </div>
        )
    }
}

RadioInput.defaultProps = {
    error: null,
    help: null,
    label: null,
    name: 'select',
    options: [],
    updateValue: () => {},
    value: null,
}

export default RadioInput



// WEBPACK FOOTER //
// ./app/components/ui/radioinput.js